import React, { useRef, useState } from "react";
import { HiDotsVertical } from "react-icons/hi";
import play_btn from "../../assets/img/play_btn.png";
import thumbnail from "../../assets/img/thumbnel.png";
import video from "../../assets/video/video.mp4";
import SlideProgress from "../Progress/SlideProgress";

export default function FundingOverview() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleTogglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="funding_overview mt-3 progress_page">
      <div className="funding_card">
        <h1>Want maximum business funding?</h1>
        <button className="btn">Start</button>
      </div>
      <div className="row video_area">
        <div className="col-lg-6">
          <div className="content">
            <h2>Overview: Personal Funding</h2>
            <div className="video-container relative mt-3">
              <video
                ref={videoRef}
                src={video}
                className="video"
                onClick={handleTogglePlay}
                preload="metadata"
              />
              {/* Thumbnail overlay */}
              {!isPlaying && (
                <div className="thumbnail-overlay flex justify-center items-center">
                  <img
                    src={thumbnail}
                    alt="Video Thumbnail"
                    className="thumbnail"
                  />
                  <div className="play-button" onClick={handleTogglePlay}>
                    <img className="icons" src={play_btn} alt="" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="content">
            <h2>Overview: Business Funding</h2>
            <div className="video-container relative mt-3">
              <video
                ref={videoRef}
                src={video}
                className="video"
                onClick={handleTogglePlay}
                preload="metadata"
              />
              {/* Thumbnail overlay */}
              {!isPlaying && (
                <div className="thumbnail-overlay flex justify-center items-center">
                  <img
                    src={thumbnail}
                    alt="Video Thumbnail"
                    className="thumbnail"
                  />
                  <div className="play-button" onClick={handleTogglePlay}>
                    <img className="icons" src={play_btn} alt="" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-4">
          <div className="card">
            <div className="header_area">
              <h3>Available Borrowing Power</h3>
              <HiDotsVertical className="icons dot-icon" />
            </div>
            <div className="mt-3">
              <p className="sub-title">Experian</p>
              <h1 className="number mt-2">$7,500</h1>
            </div>
            <div className="mt-3">
              <p className="pts">
                +6.8% <span className="status">Since last week</span>
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="card">
            <div className="header_area">
              <h3>Credit Utilization</h3>
              <HiDotsVertical className="icons dot-icon" />
            </div>
            <SlideProgress />
          </div>
        </div>
      </div>
    </div>
  );
}
